module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAfCAMAAADOWS1PAAAAS1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////+DmQsHAAAAGHRSTlMAECAwQFBgb3B/gI+Qn6CvsL/A0N/g7/DlJHxYAAAAsUlEQVQoz7XSyxaDIAxF0ZMiVFHRxkfz/1/agS6LVYa9s6zNIAmBbrWbDA6i3WcVlgJZoCQW/0cpvt6qNoTxh6bKewCcr9x0oiAcEZ/TwilLRulMMSN/JpeRAKMFCNYDfGnZSgU1A9CDFKDTCoJGgHRQB3LpY6MBJLh9qvoB47eNXiDMbdM0r06QPt/G2j73O5if7fzv/7qh60VNulN9fU/aiFp/4/ZF3SeViVQm6jIhHxRxMMAaj+gJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/f4Active.png
// module id = IIlL
// module chunks = 21